export default "__VITE_ASSET__CsJZFSR0__"